import React, {Component} from "react";

import styled from "styled-components";
import {FontStyles, Icons, Modal, PrimaryButton} from "@stacc/flow-ui-components";

import FileDisplay from "./FileDisplay";
import fileService from "../services/files";
import downloadLink from "../helpers/downloadLink";
import {Buffer} from "buffer";

class FileItem extends Component {
    constructor(props) {
        super(props);
        this.bpiClientConfig = props.bpiClientConfig;
        this.fileType = props.fileType;
        this.state = {
            displayTask: false
        };
    }

    onDownloadClick() {
        const {id, name, type, base64EncodedDocAttachment} = this.props;
        const file = type === "docAttachment" ?
            fileService.getDocAttachmentsFile(this.bpiClientConfig, id) :
            fileService.getFile(id);
        file.then(result => {
            const downloadContent = base64EncodedDocAttachment ?
                Buffer.fromBase64(new TextDecoder().decode(result.file)) :
                result.file;
            downloadLink(downloadContent, name);
        });
    }

    render() {
        const {displayTask} = this.state;
        const {id, name, type, base64EncodedDocAttachment} = this.props;

        return (
            <div>
                <TaskContainer>
                    <TaskDescription>
                        <Icons.File/>
                        <p>{name}</p>
                        <p className="small">{type}</p>
                    </TaskDescription>
                    <ButtonGroup>
                        <PrimaryButton
                            onClick={() =>
                                this.setState({displayTask: !displayTask})
                            }
                        >
                            {"Vis Fil"}
                        </PrimaryButton>
                        <PrimaryButton onClick={() => this.onDownloadClick()}>
                            {"Last Ned"}
                        </PrimaryButton>
                    </ButtonGroup>
                </TaskContainer>
                {this.state.displayTask && (
                    <Modal
                        title={name}
                        onClose={() => this.setState({displayTask: false})}>
                        <FileDisplay fileId={id}
                                     isDocAttachment={type === "docAttachment"}
                                     isBase64EncodedDocAttachment={base64EncodedDocAttachment}
                                     bpiClientConfig={this.bpiClientConfig}
                                     fileType={this.fileType}/>
                    </Modal>
                )}
            </div>
        );
    }
}

const TaskContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    ${FontStyles.LargeStrong};
`;

const ButtonGroup = styled.div`
    button {
        margin-left: 10px;
    }
`;

const TaskDescription = styled.div`
    display: flex;
    align-items: center;
    min-height: 35px;

    p {
        margin: 0;
        padding-left: 20px;

        &.small {
            ${FontStyles.Small};
        }
    }
`;

export default FileItem;
